import React from 'react'
import SkeletonLayer from '../SkeletonLayer/SkeletonLayer'
import styles from './notificationCard.scss'

const NotificationCardSkeleton = () => (
  <div id="notification-loading" className={styles.card}>
    <div className={styles.header}>
      <SkeletonLayer height={14} width={50} />
      <SkeletonLayer height={14} width={95} />
    </div>
    <div className={styles.content}>
      <div className={styles.image}>
        <SkeletonLayer height={64} width={66} />
      </div>
      <div className={styles.message}>
        <SkeletonLayer height={14} width={230} />
        <SkeletonLayer height={10} width={280} />
        <SkeletonLayer height={10} width={198} />
      </div>
    </div>
  </div>
)

export default NotificationCardSkeleton
